import { useState, useEffect, useCallback } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "./AdminShared";

export default function AdminMessagesTab({ token }) {
  const [msgs, setMsgs] = useState([]);
  const load = useCallback(() => { api(token).get("/contact").then((r) => setMsgs(r.data)).catch(() => {}); }, [token]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-3">
      <p className="text-zinc-500 text-sm mb-4">{msgs.length} message{msgs.length !== 1 ? "s" : ""}</p>
      {msgs.map((m) => (
        <div key={m.id} className="border border-white/10 rounded-xl p-4 bg-gg-surface">
          <div className="flex justify-between">
            <div><p className="text-white font-semibold text-sm">{m.name} <span className="text-zinc-500 font-normal">— {m.phone}</span></p>{m.email && <p className="text-zinc-500 text-xs">{m.email}</p>}</div>
            <div className="flex items-center gap-2">
              <span className="text-zinc-600 text-xs">{new Date(m.created_at).toLocaleDateString()}</span>
              <Button size="sm" variant="ghost" onClick={async () => { await api(token).delete(`/contact/${m.id}`); load(); }} className="text-zinc-500 hover:text-red-500"><Trash2 size={14} /></Button>
            </div>
          </div>
          {m.message && <p className="text-zinc-300 text-sm mt-2 bg-gg-black/50 rounded-lg p-3">{m.message}</p>}
        </div>
      ))}
      {msgs.length === 0 && <p className="text-zinc-600 text-sm">No messages yet</p>}
    </div>
  );
}
